// src/utils/vendorEmail.js
// The "Send to Client" email for a Vendor Directory vendor. Pure builder so
// the copy is unit-testable; sending lives in emailSender.js. House rules:
// Henry's voice, no em dashes, and the vendor's internal notes NEVER leak
// into a client email.
import { wrapBrandedEmail, plainTextToHtml } from "./emailBrandTemplate";

const firstNameOf = (name) => String(name || "").trim().split(/\s+/)[0] || "";

export function buildVendorEmailContent({ vendor = {}, note = "", toName = "", user = {} }) {
  const agentFirst =
    firstNameOf([user.firstname, user.lastname].filter(Boolean).join(" ") || user.name);
  const category = String(vendor.category || "").trim();
  const subject = `A ${category ? category.toLowerCase() : "vendor"} recommendation from ${
    agentFirst || "Team Edelstein"
  }`;

  const lines = [];
  const clientFirst = firstNameOf(toName);
  lines.push(`Hi ${clientFirst || "there"},`);
  lines.push("");
  const trimmedNote = String(note || "").trim();
  if (trimmedNote) {
    lines.push(trimmedNote);
    lines.push("");
  }
  lines.push(`Here is the ${category ? category.toLowerCase() : "vendor"} I recommend:`);
  lines.push("");
  if (vendor.name) lines.push(vendor.name);
  if (vendor.company) lines.push(vendor.company);
  if (vendor.phone) lines.push(`Phone: ${vendor.phone}`);
  if (vendor.email) lines.push(`Email: ${vendor.email}`);
  lines.push("");
  lines.push("If you reach out, feel free to mention my name. Happy to help with anything else.");

  const content = lines.join("\n");
  const text = `${content}\n\n${agentFirst ? `${agentFirst}\n` : ""}Team Edelstein`;
  const html = wrapBrandedEmail({
    contentHtml: plainTextToHtml(content),
    sender: user,
    propertyAddress: "",
  });

  return { subject, text, html };
}
